module.exports = __webpack_public_path__ + "static/media/settings.f2307c56.svg";